<template>
  <div class="avatar__wrapper">
    <img :src="avatarUrl" alt="Avatar image" class="avatar__image" title="Profile" :class="orientationClass" />
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import md5 from 'md5';
import resizedCustomAvatarUrl from './../helpers/resizedCustomAvatarUrl';
import {AVATARS, FIREBASE_STORAGE_RESIZED_IMAGE_SUFFIXES, COLOR_SCHEMES} from './../constants/globalConstants';

const userVuexModule = createNamespacedHelpers('userVuexModule');

export default {
  name: 'Avatar',
  components: {},
  data: function() {
    return {
      avatars: AVATARS,
    };
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {
    ...userVuexModule.mapGetters(['getAvatarToUse', 'getCustomAvatarOrientation', 'getCustomAvatarUrl', 'getEmail', 'getPrefersColorScheme', 'getPrefersColorSchemeTemp']),
    avatarUrl: function() {
      if (this.getAvatarToUse === this.avatars.GRAVATAR) {
        const hash = md5(this.getEmail.trim());
        return `http://www.gravatar.com/avatar/${hash}?s=240&d=mp&r=g`;
      } else if (this.getAvatarToUse === this.avatars.CUSTOM) {
        return resizedCustomAvatarUrl(this.getCustomAvatarUrl, FIREBASE_STORAGE_RESIZED_IMAGE_SUFFIXES.SIZE_200.SUFFIX);
      } else {
        const images = require.context('../assets/', false, /\.png$/);
        let filename = '';
        if (this.getPrefersColorSchemeTemp) {
          filename = `default-avatar-${this.getPrefersColorSchemeTemp.toLowerCase()}`;
        } else if (this.getPrefersColorScheme) {
          filename = `default-avatar-${this.getPrefersColorScheme.toLowerCase()}`;
        } else {
          filename = `default-avatar-${COLOR_SCHEMES.LIGHT.DEFAULT_AVATAR_SUFFIX}`;
        }
        return images(`./${filename}.png`);
      }
    },
    orientationClass: function() {
      if (this.getAvatarToUse === this.avatars.CUSTOM) {
        return `avatar__image--${this.getCustomAvatarOrientation.toLowerCase()}`;
      } else {
        return 'avatar__image--square';
      }
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.avatar {
  &__wrapper {
    background-color: var(--color-avatar-background);
    border: 1px solid var(--color-navbar-subnav-border);
    border-radius: 50%;
    overflow: hidden;
    position: relative;
  }

  &__image {
    max-width: none;

    &--landscape {
      width: auto;
      height: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    &--portrait {
      width: 100%;
      height: auto;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    &--square {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
